import { uneval } from 'devalue';

export default {
	/** Inject store data in __DATA__ on server side */
	sendSSRData({ pinia, ssr, isServer }) {
		if (!pinia || !isServer) return;

		try {
			// ssr.data.piniaState becomes window.__DATA__.piniaState
			// safely serialize state:
			const piniaState = {
				...pinia.state.value,
				routing: {
					...pinia.state.value['routing'],
					// there is one promise in our pinia state: urlMetadataPromise.
					// to make things easier, not open a new pandora's box through global variable usage, we simply override it (isn't needed for SSR).
					urlMetadataPromise: {},
				},
			};
			ssr.data.piniaState = uneval(piniaState);
			// this is needed, so other plugins can use context.ssrRouteContext to get information from the pinia store (like routing.pageType)
			// and not deserialize the pinia state again

			ssr.ssrRouteContext = {
				activeRoute: pinia.state.value.routing?.activeRoute,
				pageType: pinia.state.value.routing?.pageType,
			};
		} catch (err) {
			console.error('Pinia SSR serialization error:', err);

			throw new Error('Pinia SSR serialization error.', { cause: err });
		}
	},
};
